/**
 * Akcje zdarzeń
 *
 * @export
 * @enum {number}
 */
export enum Action {
  TEST = 'TEST'
}

export const ActionList = [{ value: Action.TEST, text: Action.TEST }];
